/**
 * Wire/DB shape for a blueprint's persisted sample row — plan
 * 2026-07-30-004 (Part B Step 2 / Part C row 6, "Persisted sample row").
 *
 * This is the SAME shape `POST /:kind/test` already accepts as its sample
 * data (`data: z.record(z.string(), JsonPrimitiveSchema)` in
 * `src/api/v4/admin-blueprints.ts`) — "card slot preview only renders
 * primitives, objects/arrays would produce `[object Object]`" applies
 * identically to a row that's persisted with the draft and later fed through
 * the exact same card-slot preview/test path. One definition, reused by:
 *   - `POST /:kind/test`'s body schema (`data`)
 *   - `CreateBlueprintSchema.sampleRow` / `UpdateBlueprintSchema.sampleRow`
 *   - `blueprints.sample_row` read-back (`parseDbJson`)
 *   - the frontend's `BlueprintRecordSchema.sampleRow` (re-exported, not
 *     redeclared — see "Schemas Are the Source of Truth" in CLAUDE.md)
 */

import { z } from 'zod';
import { JsonPrimitiveSchema } from '../schemas/json-value';

export const BlueprintSampleRowSchema = z.record(z.string(), JsonPrimitiveSchema);
export type BlueprintSampleRow = z.infer<typeof BlueprintSampleRowSchema>;
